<template>
  <Grid gtc="200px 1fr" class="stakeholders-inform-users overflow-hidden relative-position">
    <template v-if="quickViewItems">
      <ModalSidebar ref="modalSidebar" item-type="name-period" :items="quickViewItems" @item-selected="openQuickView" />

      <Grid gtr="1fr auto" class="overflow-hidden">
        <ModalBody>
          <Grid v-if="quickView" :key="quickView.id" gtc="1.2fr 1fr" gap="var(--r-space-sp)" align-items="start">
            <Grid gap="var(--r-space-md)">
              <div class="q-pa-lg bg-white-1 full-height shadow3 border-radius-sm overflow-hidden">
                <EmailTemplateEditor :quickview-data="quickView" />
              </div>

              <Grid gap="var(--r-space-md)" class="attachments q-pa-lg bg-white-1 shadow3 border-radius-sm">
                <div class="text-subtitle-1 text-secondary-2">Attachments</div>

                <EmailAttachments ref="emailAttachments" @attachments-updated="attachments = $event" />
              </Grid>
            </Grid>

            <StakeholdersTable ref="stakeholdersTable" :departments="quickView.departments_with_stakeholders" />
          </Grid>
        </ModalBody>

        <ModalFooter>
          <RBtn size="big" type="ghost" @click="dismiss">Dismiss</RBtn>
          <RBtn size="big" type="primary" @click="send">Send</RBtn>
        </ModalFooter>
      </Grid>
    </template>
  </Grid>
</template>

<script>
import * as apiTo from '@/modular-api'
import { createFormData } from '@/utils/create-form-data'
import { checkQuickView, getCount, getTaskData } from '@/reusable/workflow/task-modals/modals-shared'
// Components
import EmailAttachments from '@components/lm-blocks/EmailAttachments'
import EmailTemplateEditor from '../EmailTemplateEditor'
import ModalSidebar from '../ModalSidebar'
import ModalBody from '../ModalBody'
import ModalFooter from '../ModalFooter'
import StakeholdersTable from './StakeholdersTable'

export default {
  components: {
    EmailTemplateEditor,
    EmailAttachments,
    ModalSidebar,
    ModalBody,
    ModalFooter,
    StakeholdersTable
  },

  props: {
    isStakeholders: Boolean,
    periodId: [Number, String]
  },

  data: () => ({
    attachments: [],
    quickViewItems: null,
    quickView: null
  }),

  computed: {
    taskName() {
      if (this.isStakeholders) return 'stakeholders'
      return 'inform-users'
    }
  },

  watch: {
    quickViewItems(newVal) {
      this.$emit('subtitle', newVal)
    }
  },

  created() {
    this.getTaskData(this.taskName).then(({ data }) => (this.quickViewItems = data.result))
  },

  methods: {
    getCount,
    getTaskData,
    checkQuickView,

    openQuickView(quickViewItem) {
      this.$emit('set-loader', true)

      apiTo
        .GET_TASK_QUICK_VIEW(this.taskName, quickViewItem.id)
        .then(({ data }) => {
          this.quickView = {
            ...data.result,
            id: quickViewItem.id,
            email_template: data.result.email_templates.find(t => !!t.default)
          }
        })
        .finally(() => this.$emit('set-loader', false))
    },

    dismiss() {
      this.$emit('set-loader', true)
      apiTo
        .DISMISS_TASK(this.taskName, this.quickView.id)
        .then(() => {
          this.checkQuickView()
          this.resetAttachments()
        })
        .catch(() => this.$emit('set-loader', false))
    },

    send() {
      const formData = new FormData()
      const data = {
        stakeholders: this.$refs.stakeholdersTable.getSelectedRowsIds(),
        email_template: this.quickView.email_template,
        attachments: this.attachments || []
      }

      createFormData(formData, data)

      this.$emit('set-loader', true)
      apiTo
        .PROCESS_TASK(this.taskName, this.quickView.id, formData)
        .then(() => {
          this.checkQuickView()
          this.resetAttachments()
        })
        .catch(() => this.$emit('set-loader', false))
    },

    resetAttachments() {
      this.$refs.emailAttachments.resetEmailAttachments()
    }
  }
}
</script>
